module.exports = __webpack_public_path__ + "static/media/capped-calls@3x.d1065362.png";